const PERMISSION_KEY= "notification:sms_tracking_log";
const PAGE_URL = {
    SMS_TRACKING_LOG_PAGE: "/admin/notification/sms-tracking-log"
}

export {PERMISSION_KEY, PAGE_URL}

